// Brand Configuration - BBQ Island Liquidators (BBQ-only standalone site)

export type BrandVariant = "bbq";

export interface BrandConfig {
  name: string;
  shortName: string;
  tagline: string;
  description: string;
  path: string;
  domain: string;
  phone: string;
  email: string;
  address: {
    street: string;
    city: string;
    state: string;
    zip: string;
    full: string;
  };
  hours: {
    weekday: string;
    weekend: string;
  };
  heroHeadline: string;
  heroSubheadline: string;
  valuePropositions: {
    title: string;
    description: string;
  }[];
  categories: string[];
  socialProof: {
    savings: string;
    customers: string;
    rating: string;
    delivery: string;
  };
  seoTitle: string;
  seoDescription: string;
  theme: "light" | "dark";
}

export const COMPANY_INFO = {
  parentCompany: "The Liquidators",
  phone: "469-589-5357",
  email: "hello@bbqislandliquidators.com",
  address: {
    street: "2707 Realty Road, Suite 200B",
    city: "Carrollton",
    state: "Texas",
    zip: "75006",
    full: "2707 Realty Road, Suite 200B, Carrollton, TX 75006",
  },
  hours: {
    weekday: "Friday 10-5",
    weekend: "Saturday 10-5 | Sunday 10:30-4",
  },
};

export const brandConfigs: Record<BrandVariant, BrandConfig> = {
  bbq: {
    name: "BBQ Island Liquidators",
    shortName: "BBQ Island",
    tagline: "Premium outdoor kitchens at wholesale prices",
    description: "Transform your backyard into the ultimate grilling paradise. Factory direct savings on custom outdoor kitchens and built-in grills.",
    path: "/",
    domain: "bbqislandliquidators.com",
    phone: COMPANY_INFO.phone,
    email: COMPANY_INFO.email,
    address: COMPANY_INFO.address,
    hours: COMPANY_INFO.hours,
    heroHeadline: "FIRE UP YOUR BACKYARD",
    heroSubheadline: "Premium BBQ islands and outdoor kitchens at prices that'll make your neighbors jealous. Built-in grills, custom islands, and everything you need for the ultimate outdoor cooking experience.",
    valuePropositions: [
      { title: "Custom Built", description: "Design your dream outdoor kitchen at factory direct prices" },
      { title: "Top Brands", description: "Premium grills and appliances from leading manufacturers" },
      { title: "Pro Installation", description: "Expert installation and setup by certified technicians" },
      { title: "Full Warranty", description: "Complete warranty coverage on all components" },
    ],
    categories: ["BBQ Islands", "Built-In Grills", "Outdoor Kitchens", "Side Burners", "Refrigeration", "Accessories"],
    socialProof: { savings: "65%", customers: "8K+", rating: "5★", delivery: "Pickup" },
    seoTitle: "BBQ Island Liquidators | Outdoor Kitchens 60-70% Off | Dallas TX",
    seoDescription: "Factory direct BBQ islands and outdoor kitchens. Premium built-in grills, islands, and appliances at liquidation prices. Visit our showroom!",
    theme: "dark",
  },
};

export const getBrandConfig = (variant: BrandVariant = "bbq"): BrandConfig => {
  return brandConfigs[variant];
};

// Shared styling configurations
export const variantStyles = {
  bbq: {
    bg: "bg-bbq",
    bgLight: "bg-bbq-light",
    text: "text-bbq",
    accent: "bg-bbq-accent",
    button: "bg-bbq hover:bg-orange-600 text-white",
    border: "border-bbq",
    ring: "focus-visible:ring-bbq",
    gradient: "from-black/80 to-bbq-dark/90",
    navBg: "bg-bbq-dark",
    navText: "text-bbq-cream",
  },
};
